import { render } from "./XIconSolidBezierCurve.vue?vue&type=template&id=23008d26"
import script from "./XIconSolidBezierCurve.vue?vue&type=script&lang=js"
export * from "./XIconSolidBezierCurve.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidBezierCurve.vue"]])

export default __exports__